import React, { useState } from 'react';
import Modal from '@/components/layout/Modal';
import VBox from '@/components/layout/VBox';
import CampoSenha from '@/components/Formulario/CampoSenha';
import axios from 'axios';
import { extractApiError } from '@/lib/apiError';
import { toastSuccess, toastWarning } from '@/lib/toast';

type AlterarSenhaModalProps = {
    show: boolean;
    onSuccess: () => void;
    /** Sessão aberta por link de acesso único: o usuário não sabe a senha atual, o backend não a pede. */
    viaToken?: boolean;
};

const AlterarSenhaModal = ({ show, onSuccess, viaToken = false }: AlterarSenhaModalProps) => {
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmacaoNovaSenha, setConfirmacaoNovaSenha] = useState('');
    const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setFieldErrors({});
        setLoading(true);
        try {
            await axios.post(
                '/api/usuario/senha',
                {
                    senha_atual: viaToken ? undefined : senhaAtual,
                    nova_senha: novaSenha,
                    confirmacao_nova_senha: confirmacaoNovaSenha,
                },
                { withCredentials: true }
            );
            toastSuccess('Senha alterada com sucesso! Faça login novamente.', { autoClose: 3000 });
            onSuccess();
        } catch (err: unknown) {
            const { message, fieldErrors: errs } = extractApiError(err, 'Erro ao alterar senha');
            if (errs) {
                setFieldErrors(errs);
            } else {
                toastWarning(message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            title="Alterar senha"
            ignoreOverlayClick
            closeable={false}
            confirmProps={{ label: loading ? 'Salvando...' : 'Alterar senha', disabled: loading }}
            cancelProps={{ visible: false }}
            onConfirm={handleConfirm}
        >
            <VBox gap="16px">
                <p style={{ margin: 0, color: 'var(--tc-color-text-secondary)' }}>
                    {viaToken
                        ? 'Você entrou por um link de acesso único. Defina sua senha para continuar.'
                        : 'Por segurança, você precisa alterar sua senha antes de continuar.'}
                </p>
                {!viaToken && (
                    <CampoSenha
                        label="Senha atual"
                        value={senhaAtual}
                        onChange={setSenhaAtual}
                        error={fieldErrors?.senha_atual}
                    />
                )}
                <CampoSenha
                    label="Nova senha"
                    showStrength
                    value={novaSenha}
                    onChange={setNovaSenha}
                    error={fieldErrors?.nova_senha}
                />
                <CampoSenha
                    label="Confirmar nova senha"
                    value={confirmacaoNovaSenha}
                    onChange={setConfirmacaoNovaSenha}
                    error={fieldErrors?.confirmacao_nova_senha}
                />
            </VBox>
        </Modal>
    );
};

export default AlterarSenhaModal;
